import { __ } from '@wordpress/i18n';

const propelInit = function() {
const removeHubSpotFormStyles = (scope = document) => {
	const hubspotForm = scope.querySelectorAll(
		'.hbspt-form form.hs-custom-style'
	);

	hubspotForm.forEach(function (form) {
		form.classList.remove('hs-custom-style');
	});
};

const adjustHubSpotForms = (scope = document) => {
	const singleCheckboxListItems = scope.querySelectorAll(
		'li.hs-form-booleancheckbox:only-child'
	);

	singleCheckboxListItems.forEach((singleCheckboxListItem) => {
		if (singleCheckboxListItem.parentElement) {
			const placeHolderItem = document.createElement('li');
			placeHolderItem.classList.add('sr-only');
			singleCheckboxListItem.parentElement.appendChild(placeHolderItem);
		}
	});

	const requiredAsterisks = scope.querySelectorAll('.hs-form-required');

	requiredAsterisks.forEach((requiredAsterisk) => {
		const requiredText = document.createElement('span');
		requiredText.innerText = __('(Required)', 'propel');
		requiredText.classList.add('sr-only');
		requiredAsterisk.appendChild(requiredText);
	});

	const inputsNeedingRequiredAttribute = scope.querySelectorAll(
		'.hbspt-form .inputs-list[required] input:not([required])'
	);

	inputsNeedingRequiredAttribute.forEach((inputNeedingRequiredAttribute) => {
		inputNeedingRequiredAttribute.setAttribute('required', '');
	});
};

const observeHubSpotForms = () => {
	const hubspotForms = document.querySelectorAll('.hbspt-form');
	const config = { childList: true, subtree: true };

	hubspotForms.forEach((hubspotForm) => {
		const observer = new MutationObserver((mutationList) => {
			for (const mutation of mutationList) {
				if (!mutation.addedNodes.length) {
					continue;
				}

				const hasSubmittedMessage = Array.from(
					mutation.addedNodes
				).some(
					(node) =>
						node.classList &&
						node.classList.contains('submitted-message')
				);

				if (hasSubmittedMessage) {
					const blockForm =
						hubspotForm.closest('.block-form') ??
						hubspotForm.querySelector('.block-form');

					if (blockForm) {
						blockForm.classList.add('block-form--success');
					}

					observer.disconnect();

					break;
				}
			}
		});

		observer.observe(hubspotForm, config);
	});
};

const dispatchHubSpotFormRenderEvents = () => {
	window.addEventListener('message', (event) => {
		if (
			!event.data ||
			'hsFormCallback' !== event.data.type ||
			'onFormReady' !== event.data.eventName
		) {
			return;
		}

		const form = document.querySelector(
			`form[data-form-id="${event.data.id}"]`
		);

		const formWrapper = form ? form.closest('.hbspt-form') : null;

		if (!formWrapper) {
			return;
		}

		removeHubSpotFormStyles(formWrapper);
		adjustHubSpotForms(formWrapper);

		window.dispatchEvent(
			new CustomEvent('propel-hubspot-form-render', {
				detail: {
					formId: event.data.id,
					formWrapper,
				},
			})
		);
	});
};

removeHubSpotFormStyles();
adjustHubSpotForms();
observeHubSpotForms();
dispatchHubSpotFormRenderEvents();

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['hubspot'] = window.propel.blocks['hubspot'] || {};
window.propel.blocks['hubspot'].script = propelInit;
